import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Shareholders = React.lazy(() => import('./index'));
const ShareholderTable = React.lazy(() => import('./shareholderTable'));
const Shareholder = React.lazy(() => import('./shareholder'));
const ShareholderDetail = React.lazy(() => import('./shareholderDetail'));
const AddNewShareholder = React.lazy(() => import('./addNewShareholder'));
const EditShareholder = React.lazy(() => import('./editShareholder'));

export const useShareholderRoutes = () => {

    return (
        <Route path="shareholders" element={<Suspense fallback={<div>منتظر باشید...</div>}><Shareholders /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ShareholderTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewShareholder/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Shareholder/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ShareholderDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditShareholder/></Suspense> } />
            </Route>
        </Route>
    )
}